import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import { Link } from "react-router-dom";
import { Button, Form, Alert } from 'react-bootstrap';
import CreditCardDueService from "../OtherService/CreditCardDueService";
import CreditCardPayService from "../OtherService/CreditCardPayService";
import PaymentTypePoService from "../OtherService/PaymentTypePoService";
import PaymentTermService from "../OtherService/PaymentTermService";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import FormControl from '@mui/material/FormControl';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';


import CircularProgress from '@mui/material/CircularProgress';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';

const PayCreditCard = ({ chequeMode = false }) => {

    const { id } = useParams();

    useEffect(() => {
        fetchCreditCardDue(id);
        fetchCreditCardDetail(id);
        fetchPaymentHistory(id);
        fetchPaymentTerm();
    }, []);

    const [paymentTermList, setPaymentTermList] = useState([]);
    const [paymentTypePoList, setPaymentTypePoList] = useState([]);
    const [selectedPaymentType, setSelectedPaymentType] = useState(null);
    const [paymentHistoryList, setPaymentHistoryList] = useState([]);
    const [creditCardDueDetails, setCreditCardDueDetails] = useState({
        id: 0,
        payment_term_id: 0,
        account_number: 0,
        account_name: 0,
        account_description: '',
        payment_term: '',
        due_date: '',
        bank_name: '',
        amount: 0,
        interest_amount: 0,
        payment_due_date: '',
        status: 0,
        date: ''
    });


    const [creditCardDue, setCreditCardDue] = useState({
        id: 0,
        payment_term_id: 0,
        payment_type_po_id: 0,
        min_amount: 0,
        amount: 0,
        amount_paid: 0,
        constant_amount: 0,
        interest_amount: 0,
        is_installment: 0,
        due_date: '',
        due_date_cheque: '',
        status: 0,
        action: 'pay',
        date: ''
    });

    const [message, setMessage] = useState(false);
    const [deleteOpenModal, setDeleteOpenModal] = React.useState(false);
    const [deleteId, setDeleteId] = useState(0)
    const [submitLoading, setSubmitLoading] = useState(false);
    const [formErrors, setFormErrors] = useState({});
    const [paymentCompleted, setPaymentCompleted] = useState(false);


    const onChangecreditCardDue = (e) => {
        const { name, value } = e.target;
        setCreditCardDue(prev => ({ ...prev, [name]: value }));
        setFormErrors(prev => ({ ...prev, [name]: '' }));
    }

    const handlePaymentTermChange = (e, value) => {
        setSelectedPaymentType(null);
        setFormErrors(prev => ({
            ...prev,
            payment_term_id: '',
            payment_type_po_id: '',
            due_date_cheque: '',
        }));

        if (!value) {
            setPaymentTypePoList([]);
            setCreditCardDue(prev => ({
                ...prev,
                payment_term_id: 0,
                payment_type_po_id: 0,
            }));
            return;
        }

        const requiresBank = value.id == 2 || value.id == 3;

        setCreditCardDue(prev => ({
            ...prev,
            payment_term_id: value.id,
            payment_type_po_id: value.id == 1 ? 1 : 0,
        }));

        if (requiresBank) {
            fetchPaymentTypePo(value.id);
        } else {
            setPaymentTypePoList([]);
        }
    }

    const handlePaymentTypeChange = (e, value) => {
        setSelectedPaymentType(value);
        setFormErrors(prev => ({ ...prev, payment_type_po_id: '' }));
        setCreditCardDue(prev => ({
            ...prev,
            payment_type_po_id: value ? value.id : 0,
        }));
    }

    const fetchPaymentTypePo = ($id) => {
        PaymentTypePoService.findByCategory($id)
            .then(response => {
                setPaymentTypePoList(response.data);
            })
            .catch(e => {
                console.log("error", e)
            });
    }

    const fetchPaymentTerm = () => {
        PaymentTermService.fetchCashAndOnline()
            .then(response => {
                setPaymentTermList(response.data);
            })
            .catch(e => {
                console.log("error", e)
            });
    }



    const validatePayment = () => {
        const errors = {};
        const paymentTermEnabled = creditCardDueDetails.payment_term_id != 3;
        const bankEnabled = creditCardDue.payment_term_id == 2 || (!chequeMode && creditCardDue.payment_term_id == 3);
        const amountEnabled = !chequeMode && creditCardDueDetails.payment_term_id != 3;

        if (paymentTermEnabled && !creditCardDue.payment_term_id) {
            errors.payment_term_id = 'Payment term is required.';
        }
        if (bankEnabled && !creditCardDue.payment_type_po_id) {
            errors.payment_type_po_id = 'Bank is required.';
        }
        if (creditCardDue.payment_term_id == 3 && !creditCardDue.due_date_cheque) {
            errors.due_date_cheque = 'Cheque due date is required.';
        }
        if (amountEnabled && (!creditCardDue.amount_paid || Number(creditCardDue.amount_paid) <= 0)) {
            errors.amount_paid = 'Amount is required.';
        }

        return errors;
    };

    const savecreditCardDue = () => {
        const errors = validatePayment();
        setFormErrors(errors);

        if (Object.keys(errors).length > 0) {
            return;
        }

        const paymentData = {
            ...creditCardDue,
            amount_paid: chequeMode ? creditCardDue.constant_amount : creditCardDue.amount_paid,
            due_date: creditCardDue.payment_term_id == 3
                ? creditCardDue.due_date_cheque
                : creditCardDue.due_date,
        };

        CreditCardDueService.saveCreditCardPay(paymentData)
            .then(response => {
                const isChequeDue = chequeMode || creditCardDueDetails.payment_term_id == 3;
                const isFullyPaid = Number(paymentData.amount_paid) >= Number(creditCardDue.constant_amount);

                if (isChequeDue || isFullyPaid) {
                    setPaymentCompleted(true);
                }
                fetchCreditCardDue(id);
                fetchCreditCardDetail(id);
                fetchPaymentHistory(id);
                setMessage(true);
            })
            .catch(e => {
                console.log('saveCreditCardPay error', e.response?.data || e);
            });
    }

    const fetchPaymentHistory = (id) => {
        CreditCardPayService.fetchCreditCardPayById(id)
            .then(response => {
                setPaymentHistoryList(response.data);
            })
            .catch(e => {
                console.log("error", e)
            });
    }

    const fetchCreditCardDue = (id) => {
        CreditCardDueService.get(id)
            .then(response => {
                console.log("fetchCreditCardDue", response.data)
                setCreditCardDue({
                    id: response.data.id,
                    payment_term_id: chequeMode ? 0 : response.data.payment_term_id,
                    payment_type_po_id: chequeMode ? 0 : response.data.payment_type_po_id,
                    min_amount: response.data.min_amount,
                    amount: response.data.amount,
                    amount_paid: response.data.amount_paid,
                    interest_amount: response.data.interest_amount,
                    is_installment: response.data.is_installment,
                    due_date: response.data.due_date,
                    due_date_cheque: response.data.due_date_cheque || '',
                    status: response.data.status,
                    constant_amount: response.data.amount - response.data.amount_paid,
                });


            })

            .catch(e => {
                console.log("error", e)
            });
    }

    const fetchCreditCardDetail = (id) => {
        CreditCardDueService.fetchCreditCardDetail(id)
            .then(response => {
                setCreditCardDueDetails(response.data);
            })
            .catch(e => {
                console.log("error", e)
            });
    }

    const openDelete = (id) => {
        console.log('delete', id);
        setDeleteId(id)
        setDeleteOpenModal(true);
    }

    const handleDeleteCloseModal = () => {
        setDeleteOpenModal(false);
    };

    const deletepaymentHistory = (deleteId, e) => {
        setSubmitLoading(true);
        CreditCardPayService.delete(deleteId)
            .then(response => {
                // setValidator({
                //     severity: 'success',
                //     message: 'Deleted Successfully',
                //     isShow: true,
                // });

                // fetchCreditCardDue(id);
                fetchCreditCardDue(id);
                fetchCreditCardDetail(id);
                fetchPaymentHistory(id);
                fetchPaymentTerm();

                setSubmitLoading(false);
                setDeleteOpenModal(false);
            })
            .catch(e => {
                setSubmitLoading(false);
                setDeleteOpenModal(false);
                console.log('error', e);
            });
    }



    const numberFormat = (value) =>
        new Intl.NumberFormat('en-us', {
            style: 'currency',
            currency: 'PHP'
        }).format(value).replace(/(\.|,)00$/g, '');



    return (
        <div>
            {message &&
                <Alert variant="success" dismissible>
                    <Alert.Heading>Successfully Updated!</Alert.Heading>
                    <p>
                        Change this and that and try again. Duis mollis, est non commodo
                        luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.
                        Cras mattis consectetur purus sit amet fermentum.
                    </p>
                </Alert>
            }
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 700 }} aria-label="spanning table">
                    <TableBody>
                        <TableRow >
                            <TableCell style={{ fontWeight: 'bold' }}>Type</TableCell>
                            <TableCell align="right">{creditCardDueDetails.payment_term}</TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>Bank</TableCell>
                            <TableCell align="right">{creditCardDueDetails.bank_name}</TableCell>


                            <TableCell style={{ fontWeight: 'bold' }}>Account Name:</TableCell>
                            <TableCell align="right">{creditCardDueDetails.account_name}</TableCell>

                            <TableCell style={{ fontWeight: 'bold' }}>Details:</TableCell>
                            <TableCell align="right">{creditCardDueDetails.account_description}</TableCell>

                            <TableCell style={{ fontWeight: 'bold' }}>Account Number:</TableCell>
                            <TableCell align="right">{creditCardDueDetails.account_number}</TableCell>


                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            <br></br>
            {creditCardDueDetails.payment_term_id == 4 ? (<>
                <TableContainer component={Paper}>

                    <Table sx={{ minWidth: 700 }} aria-label="spanning table">
                        <TableBody>
                            <TableRow >
                                <TableCell style={{ fontWeight: 'bold' }}>Due Date</TableCell>
                                <TableCell align="right">{creditCardDueDetails.payment_due_date}</TableCell>

                                <TableCell style={{ fontWeight: 'bold' }}>Due Amount:</TableCell>
                                <TableCell align="right">{creditCardDue.constant_amount}</TableCell>

                                <TableCell style={{ fontWeight: 'bold' }}>Minimum Amount:</TableCell>
                                <TableCell align="right">{creditCardDueDetails.min_amount}</TableCell>

                                <TableCell style={{ fontWeight: 'bold' }}>Penalty:</TableCell>
                                <TableCell align="right">{creditCardDueDetails.interest_amount}</TableCell>


                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </>) : <>
                {/* <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 700 }} aria-label="spanning table">
                        <TableBody>
                            <TableRow >
                                <TableCell style={{ fontWeight: 'bold' }}>Due Amount:</TableCell>
                                <TableCell align="right">{creditCardDue.amount - creditCardDue.amount_paid}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer> */}
            </>}
            <br></br>
            {creditCardDue.status == 0 && !paymentCompleted &&
                <Box
                    sx={{
                        '& .MuiTextField-root': { m: 1, width: '25ch' },
                    }}
                    noValidate
                    autoComplete="off"
                // onSubmit={saveOrderSupplier}
                >
                    <Form>


                        {creditCardDueDetails.payment_term_id == 4 &&
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Minimum Amount</Form.Label>
                                <Form.Control type="text" value={creditCardDue.min_amount} name="min_amount" onChange={onChangecreditCardDue} disabled />
                            </Form.Group>
                        }

                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Due Date</Form.Label>
                            <Form.Control type="date" value={creditCardDue.due_date} name="details" onChange={onChangecreditCardDue} disabled />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Due Amount</Form.Label>
                            <Form.Control type="text" value={creditCardDue.constant_amount} name="amount" onChange={onChangecreditCardDue} disabled />
                        </Form.Group>

                        {/* {formErrors.payment_term_id && <p style={{ color: "red" }}>{formErrors.payment_term_id}</p>} */}


                        {(chequeMode || creditCardDueDetails.payment_term_id != 3) ? (<>
                            <FormControl variant="standard" >
                                <Autocomplete
                                    // {...defaultProps}
                                    options={paymentTermList}
                                    className="mb-3"
                                    id="disable-close-on-select"
                                    onChange={handlePaymentTermChange}
                                    getOptionLabel={(paymentTermList) => paymentTermList.payment_term}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Choose Payment Term"
                                            variant="standard"
                                            required
                                            error={Boolean(formErrors.payment_term_id)}
                                            helperText={formErrors.payment_term_id}
                                        />
                                    )}
                                />
                            </FormControl>
                        </>) : <>
                            {/* <FormControl variant="standard" >
                                <Autocomplete
                                    // {...defaultProps}
                                    options={paymentTermList}
                                    className="mb-3"
                                    id="disable-close-on-select"
                                    onChange={handlePaymentTermChange}
                                    getOptionLabel={(paymentTermList) => paymentTermList.payment_term}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Choose Payment Term" variant="standard" />
                                    )}
                                />
                            </FormControl> */}
                        </>}
                        <br></br>
                        {(creditCardDue.payment_term_id == 2 || (!chequeMode && creditCardDue.payment_term_id == 3)) ? (<>
                            {/* {formErrors.payment_type_po_id && <p style={{ color: "red" }}>{formErrors.payment_type_po_id}</p>} */}
                            <Box
                                sx={{
                                    '& .MuiTextField-root': { m: 1, width: '65ch' },
                                }}
                                noValidate
                                autoComplete="off"
                            >
                                <FormControl variant="standard" >
                                    <Autocomplete
                                        // {...defaultProps}
                                        options={paymentTypePoList}
                                        value={selectedPaymentType}
                                        className="mb-3"
                                        id="disable-close-on-select"
                                        onChange={handlePaymentTypeChange}
                                        getOptionLabel={(paymentTypePoList) => paymentTypePoList.bank_name + " " + paymentTypePoList.account_name + "  " + paymentTypePoList.account_description + " - " + paymentTypePoList.account_number}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Choose Bank"
                                                variant="standard"
                                                required
                                                error={Boolean(formErrors.payment_type_po_id)}
                                                helperText={formErrors.payment_type_po_id}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Box>
                            {!chequeMode && creditCardDue.payment_term_id == 3 &&
                                <Form.Group className="mb-3" controlId="chequeDueDate">
                                    <Form.Label>Due Date For Cheque</Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={creditCardDue.due_date_cheque}
                                        name="due_date_cheque"
                                        onChange={onChangecreditCardDue}
                                        required
                                        isInvalid={Boolean(formErrors.due_date_cheque)}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formErrors.due_date_cheque}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            }
                        </>) : ""}

                        {!chequeMode && creditCardDueDetails.payment_term_id != 3 ? (<>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Amount</Form.Label>
                                <Form.Control
                                    type="number"
                                    min="0.01"
                                    step="0.01"
                                    name="amount_paid"
                                    placeholder="Enter Amount"
                                    onChange={onChangecreditCardDue}
                                    required
                                    isInvalid={Boolean(formErrors.amount_paid)}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {formErrors.amount_paid}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </>) :
                            <>

                            </>

                        }
                        {creditCardDueDetails.payment_term_id != 3 ? (<>

                            <Button variant="primary" onClick={savecreditCardDue}>
                                Submit
                            </Button>
                        </>) :
                            <>

                                <Button variant="primary" onClick={savecreditCardDue}>
                                    Pay
                                </Button>
                            </>

                        }


                    </Form>
                </Box>
            }
            <br></br>
            {paymentHistoryList.length != 0 &&
                <>
                    <legend align="center" style={{ fontWeight: 'bold' }} > Payment History </legend>
                    <table class="table table-bordered">
                        <thead class="table-dark">
                            <tr class="table-secondary">
                                <th>ID</th>
                                <th> Amount</th>
                                <th> Bank</th>
                                <th> Account Name</th>
                                <th> Account Nuumber</th>
                                <th> Date</th>
                                <th></th>
                                <th></th>


                            </tr>
                        </thead>
                        <tbody>

                            {
                                paymentHistoryList.map((paymentHistory, index) => (
                                    <tr key={paymentHistory.id} >
                                        <td>{paymentHistory.id}</td>
                                        <td>{numberFormat(paymentHistory.amount)} </td>
                                        <td>{paymentHistory.bank_name + " " + paymentHistory.account_description}</td>
                                        <td>{paymentHistory.account_name}</td>
                                        <td>{paymentHistory.account_number}</td>
                                        <td>{paymentHistory.updated_at}</td>
                                        <td>
                                            <Link variant="primary" to={"/payCreditCardHistory/" + paymentHistory.id}   >
                                                <Button  >
                                                    Update
                                                </Button>
                                            </Link>
                                        </td>
                                        <td>
                                            <Tooltip title={chequeMode ? "Delete payment" : "Delete disabled"}>
                                                <IconButton
                                                    disabled={!chequeMode}
                                                    onClick={chequeMode ? (e) => openDelete(paymentHistory.id, e) : undefined}
                                                >
                                                    <DeleteIcon color={chequeMode ? "error" : "disabled"} />
                                                </IconButton>
                                            </Tooltip>
                                        </td>



                                    </tr>
                                )
                                )
                            }
                        </tbody>
                    </table>
                </>
            }

            <Dialog
                open={deleteOpenModal}
                onClose={handleDeleteCloseModal}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >

                <DialogTitle id="alert-dialog-title">
                    {"Are you sure you want to Delete?"}
                </DialogTitle>
                {submitLoading &&
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <CircularProgress />
                    </div>
                }
                <DialogActions>
                    <Button onClick={handleDeleteCloseModal}>Cancel</Button>
                    <Button onClick={(e) => deletepaymentHistory(deleteId, e)} autoFocus>
                        Agree
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default PayCreditCard
